import * as ActionTypes from '../store/ActionTypes';
import { axiosInstance } from './api';

export const actionCreators = {
    getBranches: (branches) => ({ type: ActionTypes.getBranches, payload: branches }),
    getClubs: (clubs) => ({type:ActionTypes.getClubs, payload: clubs}),
    getBranch: (branch) => ({ type: ActionTypes.getBranch, payload: branch }),
    updateBranch: (branch) => ({ type: ActionTypes.updateBranch, payload: branch }),
    createBranch: (branch) => ({ type: ActionTypes.createBranch, payload: branch }),
    setBranch: (branch) => ({ type: ActionTypes.getBranch, payload: branch }),
    updateResponse: (response) => ({ type: ActionTypes.updateResponse, payload: response })
};

export const createBranch = (branch) => {
    return dispatch => {
        const url = `Branch/PostAsync`;
        return axiosInstance().post(url, branch).then(response => {
            dispatch(actionCreators.updateBranch(response))
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const getClubs = (callback, context) => {
    return dispatch => {
            const url = `Club/GetClubsAsync`;
            return axiosInstance().get(url).then(response => {
                dispatch(actionCreators.getClubs(response.data.data))
                callback(response, context);
            }).catch(response => callback(response.response, context));
    }
}

export const getBranches = (callback, context, filter) => {
    return dispatch => {
        // if (!filter) {
        //     console.log("nofilter");
        //     var pageIndexed = page + 1;
            const url = `Branch/SearchBranches?filter=${filter}`;
            return axiosInstance().get(url).then(response => {
                dispatch(actionCreators.getClubs(response.data.data))
                callback(response, context);
            }).catch(response => callback(response.response, context));
    }
}

export const getBranchesPaginated = (filter, pageNumber, pageSize, orderBy, descending, onlyActive) => {
    const url = `Branch/GetBranchesPaginatedAsync?filter=${filter}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&descending=${descending}&onlyActive=${onlyActive}`;
    return axiosInstance().get(url);
}

export const updateResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateResponse(response));
    }
}

export const updateBranch = (branch) => {
    return dispatch => {
        console.log(branch);
        const url = `Branch/PutAsync`;
        return axiosInstance().put(url, branch).then(response => {
            dispatch(actionCreators.updateBranch(response))
            console.log(response, "response")
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const getBranch = (callback, context, id) => {
    return dispatch => {
            const url = `Branch/GetBranchById/${id}`;
            return axiosInstance().get(url).then(response => {
                dispatch(actionCreators.getBranches(response.data.data))
                callback(response, context);
            }).catch(response => callback(response.response, context));
    }
}

    // async getBranchesByClubId(id) => (dispatch) => {
    //     const url = `/Branch/GetBranchesAsync/${id}`;
    //     return axios.get(url).then(response => {response.data; dispatch(actionCreators.listBranches(response.data))});
    // }

//     async getBranch(branchId) {
//         const url = `/Branch/GetBranchById/${branchId}`;
//         return axios.get(url).then(response => response.data);
//     }

//     async updateBranch(branch) {
//         const url = `/Branch/PutAsync`;
//         console.log(branch);
//         return axios.put(url, branch).then(response => response.data);
//     }

    

//     async createBranchByClubId(branch) {
//         const url = `/Branch/PostAsync`;
//         console.log(url, branch);
//         return axios.post(url, branch).then(response => response.data);
//     }

//     async getLocationsByBranchId(branchId) {
//         const url = `/Location/${branchId}`;
//         return axios.get(url).then(response => response.data);
//     }
// }
// export default BranchApi;

